import { render } from "./assets.vue?vue&type=template&id=000fe85b&scoped=true"
import script from "./assets.vue?vue&type=script&lang=js"
export * from "./assets.vue?vue&type=script&lang=js"

import "./assets.vue?vue&type=style&index=0&id=000fe85b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000fe85b"]])

export default __exports__